<template>
  <div>
    <!-- Signature Input -->
    <mdl-textfield
      field-id="signatureTyped"
      label="Your Signature"
      :bvalue="signature"
      @inputting="updateSignature"
      placeholder="Type here to sign"
      :show-chars-limit="true"
      char-limit="30"
      :is-cursive="true"
    />

    <!-- Canvas (hidden from UI) -->
    <canvas id="cvs" height="50" />
  </div>
</template>

<script>
import mdlTextfield from '@/components/mdlTextfield.vue';

export default {
  components: {
    mdlTextfield
  },
  props: {
    underline: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      ctx: null,
      signature: ''
    };
  },
  mounted() {
    this.ctx = document.getElementById('cvs').getContext('2d');
    this.ctx.strokeStyle = 'black';
    this.ctx.lineWidth = 1;
    this.ctx.font = '25px Brush Script MT';
  },
  methods: {
    updateSignature(s) {
      // Get latest signature value and clear existing signature from canvas
      this.signature = s;
      this.clearSignature();

      // Determine size of font, based on length of signature
      const fontSize = this.getFontSize();
      this.ctx.font = `${fontSize}px Brush Script MT`;

      // Draw the latest signature value into the canvas
      this.ctx.fillText(this.signature, 10, 30);

      // Underline signature, if proxy template is not Ontario Bill 106
      if (this.underline) {
        const {width} = this.ctx.measureText(this.signature);
        this.ctx.fillRect(10, 30, width, 2);
      }

      // Update the new signature image
      const img = this.signature
        ? document.getElementById('cvs').toDataURL('image/png')
        : null;
      this.$emit('update', img);
    },
    clearSignature() {
      this.ctx.clearRect(
        0,
        0,
        document.getElementById('cvs').width,
        document.getElementById('cvs').height
      );
    },
    getFontSize() {
      let size = 25;
      if (this.signature.length > 18) {
        size = 22;
      }
      if (this.signature.length > 23) {
        size = 19;
      }
      if (this.signature.length > 26) {
        size = 17;
      }
      return size;
    }
  }
};
</script>

<style>
canvas {
  display: none;
}
</style>
